@import 'styles/mixins';
@import 'styles/variables';

.footer {
  margin-top: auto;
}

.back {
  justify-self: flex-start;
  white-space: nowrap;
}

.container {
  display: grid;
  grid-template-columns: minmax(min-content, auto) 1fr;
  row-gap: 12px;
  column-gap: 12px;
}

.titleWrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.roleButtons {
  margin-top: -10px;
  display: flex;
  align-items: center;
  grid-column-start: 2;
  margin-bottom: 4px;
}

.checkboxLabel {
  @include lg-regular;
  color: $grey-50;
  column-gap: 4px;
  display: flex;
  align-items: center;

  .icon {
    display: flex;
    align-items: center;

    svg {
      fill: $grey-50;
    }
  }
}

.schedule {
  display: flex;
  height: 100%;

  .scheduleField {
    gap: 8px;
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;
    @include lg-regular;
    color: $grey-40;
  }

  .scheduleField + .scheduleField {
    padding-left: 12px;

    &:after {
      content: '';
      background: $grey-10;
      bottom: 25%;
      position: absolute;
      left: 0;
      height: 50%;
      width: 1px;
    }
  }

  @include for-medium-phone-only {
    flex-direction: column;
    align-items: start;

    .scheduleField + .scheduleField {
      padding-right: 12px;
      padding-bottom: 6px;
    }
  }
}
